import { apiFetch } from "../utils/apiFetch"

export function saveDesignApplicationDraft(data: any) {
  return apiFetch("/api/design-applications", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function getDesignApplicationDrafts() {
  return apiFetch("/api/design-applications")
}

export function getDesignApplicationById(id: string) {
  return apiFetch(`/api/design-applications/${id}`)
}

export function updateDesignApplicationDraft(id: string, data: any) {
  return apiFetch(`/api/design-applications/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function updateDesignApplicationStatus(id: string, status: string) {
  return apiFetch(`/api/design-applications/${id}/status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status })
  })
}

export function validateDesignApplication(id: string) {
  return apiFetch(`/api/euipo/design-filing/validate/${id}`, {
    method: "POST"
  })
}

export function submitDesignApplication(id: string) {
  return apiFetch(`/api/euipo/design-filing/submit/${id}`, {
    method: "POST"
  })
}

export function deleteDesignApplicationDraft(id: string) {
  return apiFetch(`/api/design-applications/${id}`, { method: "DELETE" })
}

export function duplicateDesignApplicationDraft(id: string) {
  return apiFetch(`/api/design-applications/${id}/duplicate`, { method: "POST" })
}
